// src/shared/components/toast/toast-container.tsx
'use client';

import { createPortal } from 'react-dom';
import clsx from 'clsx';
import { useToastStore } from '@/shared/components/toast/toast-store';

export const TOAST_ID = 'toast-root';

export const ToastContainer = () => {
  const { toasts } = useToastStore();
  if (typeof document === 'undefined') return null;

  return createPortal(
    <div className='fixed top-4 right-4 z-[1000] flex flex-col gap-2'>
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={clsx(
            'animate-fade-in-up rounded-md px-4 py-2 text-white shadow-lg transition-all duration-300',
            toast.type === 'success' && 'bg-success',
            toast.type === 'error' && 'bg-red-500',
            toast.type === 'info' && 'bg-blue-400',
          )}
        >
          {toast.message}
        </div>
      ))}
    </div>,
    document.body,
  );
};
